import React from 'react'
import { useHistory } from 'react-router'
import { useAppSelector } from '../../../../../../hooks/redux'

import { PAGE_SIZE } from '../../../../../../components/molecules/TaskWidget'

import { Routes } from '../../../../../../Routes'
import { fetchDashboardTasks } from '../../../../../../lib/api'
import { selectTaskStatus } from '../../../../../../slices/taskStatus'
import { useTaskList } from '../../../../../../providers/TaskListProvider'
import { useEnvironment } from '../../../../../../providers/EnvironmentProvider'
import useStyles from './styles'

type TaskRowProps = {
  tasks: (APITask & { status: string })[]
  after: string
}

const TaskRow = ({ tasks, after }: TaskRowProps) => {
  const history = useHistory()

  const { statuses } = useAppSelector(selectTaskStatus)

  const { setMore, setIDs, addTasks } = useTaskList()
  const { user } = useEnvironment()

  const userID = React.useMemo(() => user?.id, [user])

  const classes = useStyles()

  const handleClick = React.useCallback(
    async (task: APITask & { status: string }) => {
      const taskIDs = tasks.map(t => t.id)

      setMore(() => {
        let nextToken = after
        let done = false

        return async () => {
          if (done) {
            return
          }

          try {
            const { data: newTasks, next: newToken } =
              await fetchDashboardTasks(userID, PAGE_SIZE, nextToken)
            nextToken = newToken
            if (!newToken) {
              done = true
            }
            addTasks(newTasks.map(t => t.id))
          } catch (err) {
            console.error('Error getting dashboard tasks', err)
          }
        }
      })

      setIDs(taskIDs, task.id)

      history.push(`${Routes.TASKS}/${task.id}`)
    },
    [addTasks, after, history, setIDs, setMore, userID, tasks]
  )

  return [
    <div key='open-tasks-header' className={classes.headerContainer}>
      <div className={classes.taskItemHeader}>
        <div className={classes.mobileColors}>
          <div className={classes.statusColors}>
            <div className={classes.dot} />

            <span className={classes.statusTitle}>Status</span>
          </div>
        </div>

        <div className={classes.taskTitles}>Title</div>
      </div>

      <div className={classes.separator}>
        <div />
      </div>
    </div>,

    ...tasks.map((task, i) => (
      <div
        key={`${task.id}-${i}`}
        onClick={() => handleClick(task)}
        className={classes.taskItem}
      >
        <div className={classes.mobileColors}>
          <div className={classes.statusColors}>
            <div
              className={classes.dot}
              style={{
                backgroundColor: `#${
                  statuses.find(s => s.id === task.status_id)?.colour ??
                  'F1F1F1'
                }`
              }}
            />

            <span className={classes.statusTitle}>
              {task.status === '' ? 'No status' : task.status}
            </span>
          </div>
        </div>

        <div className={classes.taskTitles}>{task.title}</div>
      </div>
    ))
  ]
}

export default TaskRow
